export default "__VITE_ASSET__uKRIWYKH__"